/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { message } from './message';

export class messagereference extends IceEntity {
  message_reference_key: string = "";
  message_key: string = "";
  parent_message_key: string = "";
  message_date: any = NaN;
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  reminder_key: string = "";
  message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  trans_type: number = 0;
  from: string = "";
  to: string = "";
  subject: string = "";
  blog: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;
  requested_access_trans_account: string = "";
  requested_access_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  requested_access_country_id: string = "";

  constructor(cpy?: messagereference) {
    super();
    if (cpy != null) {
      this.message_reference_key = cpy.message_reference_key;
      this.message_key = cpy.message_key;
      this.parent_message_key = cpy.parent_message_key;
      this.message_date = cpy.message_date;
      this.trans_account = cpy.trans_account;
      this.account_type = cpy.account_type;
      this.reminder_key = cpy.reminder_key;
      this.message_status = cpy.message_status;
      this.trans_type = cpy.trans_type;
      this.from = cpy.from;
      this.to = cpy.to;
      this.subject = cpy.subject;
      this.blog = cpy.blog;
      this.record_version = cpy.record_version;
      this.offline_record_status = cpy.offline_record_status;
      this.requested_access_trans_account = cpy.requested_access_trans_account;
      this.requested_access_account_type = cpy.requested_access_account_type;
      this.requested_access_country_id = cpy.requested_access_country_id;
    }
  }
  gettablename(): string {
      return "MESSAGE_REFERENCE";
  }

  copy(cpy: message): void {
    if (cpy != null) {
      this.message_key = cpy.message_key;
      this.parent_message_key = cpy.parent_message_key;
      this.message_date = cpy.message_date;
      this.trans_account = cpy.trans_account;
      this.account_type = cpy.account_type;
      this.message_status = cpy.message_status;
      this.trans_type = cpy.trans_type;
      this.from = cpy.from;
      this.to = cpy.to;
      this.subject = cpy.subject;
      this.blog = cpy.blog;
      this.requested_access_trans_account = cpy.requested_access_trans_account;
      this.requested_access_account_type = cpy.requested_access_account_type;
      this.requested_access_country_id = cpy.requested_access_country_id;
    }
  }
}

